import * as base from './base';
import * as types from 'constants/action-types';
import * as api from 'api';

export const fetchSchools = (q, page = 1, perPage, sortOpts, extraFilters) =>
  base.fetchRecords(api.fetchSchools, setSchools, q, page, perPage, sortOpts, extraFilters);

export const setSchools = (records, currentPage, pageCount, totalCount, itemsPerPage) => ({
  type: types.SET_SCHOOLS,
  records,
  currentPage,
  pageCount,
  totalCount,
  itemsPerPage,
});

export const fetchSchool = (recordId) => (dispatch) =>
  api.fetchSchool(recordId).then((response) => {
    dispatch(setCurrentSchool(recordId, response.record));
  });

export const setCurrentSchoolPage = (page) => ({
  type: types.SET_CURRENT_SCHOOL_PAGE,
  page,
});

export const setCurrentSchool = (recordId, recordData) => ({
  type: types.SET_CURRENT_SCHOOL,
  recordId,
  recordData,
});

export const clearSchoolsAfterPage = (page) => ({
  type: types.CLEAR_SCHOOLS_AFTER_PAGE,
  page,
});

export const fetchSchoolFaculties = (schoolId, q, page = 1, perPage, sortOpts, extraFilters) =>
  base.fetchRecords(
    (q, page, perPage, sortOpts, extraFilters = {}) =>
      api.fetchUsers(q, page, perPage, sortOpts, {...extraFilters, schoolId, role: 'teacher'}),
    setSchoolFaculties,
    q,
    page,
    perPage,
    sortOpts,
    extraFilters,
  );

export const setSchoolFaculties = (records, currentPage, pageCount, totalCount, itemsPerPage) => ({
  type: types.SET_SCHOOL_FACULTIES,
  records,
  currentPage,
  pageCount,
  totalCount,
  itemsPerPage,
});

export const setCurrentSchoolFacultyPage = (page) => ({
  type: types.SET_CURRENT_SCHOOL_FACULTY_PAGE,
  page,
});

export const setCurrentSchoolFaculty = (recordId, recordData) => ({
  type: types.SET_CURRENT_SCHOOL_FACULTY,
  recordId,
  recordData,
});

export const clearSchoolFacultiesAfterPage = (page) => ({
  type: types.CLEAR_SCHOOL_FACULTIES_AFTER_PAGE,
  page,
});
